<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.Sending_mail_records')"></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ send_user: true ,email_title: true }" />
        <myTable ref="table" :columns="columns" requestUrl="mailinfo/log/list" :showPage="true">
          <template v-slot:detail="{ data }">
            <Icon
              class="cursor_p"
              @click="handleToDetail(data.row)"
              type="ios-eye"
              size="26"
              color="#7D7C7F"
            />
          </template>
        </myTable>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "@/components/pageTitle";
import myTableFilter from "@/components/myTableFilter";
import myTable from "@/components/myTable";

export default {
  name: "expire",
  components: {
    myTableFilter,
    myTable,
    pageTitle
  },
  data () {
    return {
      columns: [
        // {
        //   title: this.$t("cms_email.id"),
        //   key: "mailinfo_id",
        //   align: "center"
        // },
        {
          title: this.$t("cms_email.addTime"),
          key: "add_time",
          align: "center"
        },
        {
          title: this.$t("cms_email.send_user"),
          key: "send_user",
          align: "center"
        },
        {
          title: this.$t("cms_email.title"),
          key: "title",
          align: "center"
        },
        {
          title: this.$t("cms_email.content"),
          tooltip: true,
          key: "content",
          align: "center"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "detail"
        }
      ],
      search: { page: 1, limit: 10 },
      list: [],
      total: 0
    };
  },
  created () {
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    handleToDetail (item) {
      this.$base.linkTo("/email/record_detail", {
        id: item.log_id,
      });
    }
  }
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/email/record/record.vue